import { Injectable } from '@angular/core';
import { MultiBrandPassModalComponent } from '@app/shared/components/multi-brand-pass-modal/multi-brand-pass-modal.component';
import { CartService } from '@core/services/cart/cart.service';
import { CustomizationService } from '@core/services/customization/customization.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DeviceService } from '@core/services/util/device.service';
import { CustomizationUtilService } from '@core/services/customization-util/customization-util.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { InfoDialogComponent } from '@app/shared/components/info-dialog/info-dialog.component';
import { Outlet } from '@app/shared/models/api-response/catalog-api-response';

@Injectable({
    providedIn: 'root'
})
export class MenuUtilService {
    isMobile = false;
    cartItems: any;
    dialogRef: MatDialogRef<any>;

    constructor(
        private cartService: CartService,
        private customizationService: CustomizationService,
        private bottomSheet: MatBottomSheet,
        private deviceService: DeviceService,
        private customizationUtil: CustomizationUtilService,
        private dialogBox: MatDialog
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.cartService.state.subscribe((cart: any) => {
            this.cartItems = Object.values(cart.items);
        });
    }

    updateCart(operation, productId, menu) {
        const productSize = menu.products[productId].product_sizes[0];
        let customizaitonString = '';

        if (productSize.product_customization_types.length > 0) {
            customizaitonString = this.customizationService.getDefaultCustomizationsString(
                productSize.product_customization_types
            );
        }

        if (operation.type === 'add' && this.cartService.multiBrandOrderAllowed(productId)) {
            if (!this.cartService.checkMaxLimit(productId, menu)) {
                return;
            }

            if (this.customizationService.toShowCustomizationModal(productId, menu)) {
                let item;
                if (this.cartItems) {
                    const items = this.cartItems.filter((product: any) => product.ids.product_id === productId);
                    item = items[items.length - 1];
                }

                if (operation.count > 0) {
                    return this.customizationUtil.repeatCustomize(item, menu);
                }
                return this.customizationUtil.openCustomizationModel({ product_id: productId }, menu);
            } else {
                return this.cartService.addItem(productId, productSize.id, customizaitonString);
            }
        }

        if (operation.type === 'remove') {
            // remove the element from the cart, or show alert to remove from cart, because multiple variations are added.
            return this.cartService.removeItem(productId, menu.menu_id);
        }
    }

    openProductPassesModal(panelClass = [], pageName = '') {
        const data = {};

        if (pageName) {
            data['page'] = pageName;
        }
        if (this.isMobile) {
            this.bottomSheet.open(MultiBrandPassModalComponent, {
                panelClass: [...panelClass, 'passes-dialog'],
                backdropClass: 'passes-dialog-backdrop',
                data
            });
        } else {
            this.dialogBox.open(MultiBrandPassModalComponent, {
                height: '85%',
                width: '45vw',
                panelClass: ['passes-dialog', 'desktop-passes-dialog'],
                backdropClass: 'passes-dialog-backdrop',
                data
            });
        }
    }

    handleDisabledState(product: any, outlet: Outlet) {
        if (product.sold_out) {
            return;
        }

        this.showDisableReason(outlet);
    }

    showDisableReason(outlet: Outlet) {
        const {
            outlet_status_strip: { message }
        } = outlet;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.maxWidth = 500;
        dialogConfig.minWidth = 350;
        dialogConfig.panelClass = 'info-dialog';
        dialogConfig.data = { message };
        this.dialogBox.open(InfoDialogComponent, dialogConfig);
    }
}
